import {mapActions, mapGetters, mapMutations} from 'vuex';
import Item from '../../components/list-item/index.vue'
import HeadFilter from '@/components/features/head-filter/index.vue'
import BtnLoadMore from '@/components/atoms/buttons/load-more/index.vue'
import {seo} from '@/mixins/seo'

export default {
    name: 'course-materials',
    mixins: [seo],
    components: {
        Item,
        HeadFilter,
        BtnLoadMore
    },
    created() {
        if (!this.categories.length) {
            this.fetchCategories()
        }
        if (!this.isLoading && !this.list.length) {
            this.fetchList({isResetList: true})
        }
        this.seo.title = this.$t('actionPlans')
    },
    beforeRouteLeave(to, from, next) {
        if (to.name !== 'action-plans-detail') {
            this.changeCategory()
        }
        next();
    },
    computed: {
        ...mapGetters({
            list: 'actionPlans/list',
            listLength: 'actionPlans/listLength',
            isLoading: 'actionPlans/isLoading',

            categories: 'education/categories',
            isLoadingCategories: 'education/isLoadingCategories',
        }),
    },
    methods: {
        ...mapActions({
            fetchList: 'actionPlans/GET_LIST',
            fetchCategories: 'education/GET_CATEGORIES',
        }),
        ...mapMutations({
            changeCategory: 'actionPlans/CHANGE_CATEGORY',
            setCategories: 'education/SET_CATEGORIES',
        }),
    },
}
